import AtpolSTPContent from "../../components/layouts/tentang/AtpolSTPContent";

import React from "react";

const AtpolSTP: React.FC = () => {
  return (
    <div>
      <AtpolSTPContent />
    </div>
  );
};

export default AtpolSTP;
